<template>
    <div class="emam-list">
        <van-swipe class="my-swipe" lazy-render :loop=false :show-indicators=false ref="swipe">
            <van-swipe-item v-for="(item, index) in rows" :key="index">
                <div class="emam-swipe-each">
                    <div class="emam-each">
                        <div class="emam-head">
                            <div class="emam-head-left">
                                <div class="emam-type-icon"></div>
                                <template v-if="item.type === '0'">
                                    <div class="emam-type">单选题</div>
                                </template>
                                <template v-if="item.type === '1'">
                                    <div class="emam-type">多选题</div>
                                </template>
                                <template v-if="item.type === '2'">
                                    <div class="emam-type">判断题</div>
                                </template>
                            </div>
                            <div class="emam-index"><span>{{ index + 1 }}</span>/{{ rows.length }}</div>
                        </div>
                        <div class="emam-info">
                            <div class="emam-content">{{ item.content }}</div>
                            <div class="emam-optiond-list">
                                <template v-if="item.type === '0'">
                                    <div class="emam-optiond-each" :class="{ 'select': item.work === item1.optionNo }"
                                        v-for="(item1, index1) in item.itemOptionList" :key="index1"
                                        @click="selectOption(item1, index)">
                                        {{ item1.optionNo }}. {{ item1.optionContent }}
                                    </div>
                                </template>
                                <template v-else-if="item.type === '1'">
                                    <div class="emam-optiond-each"
                                        :class="{ 'select': item.work && item.work.includes(item1.optionNo) }"
                                        v-for="(item1, index1) in item.itemOptionList" :key="index1"
                                        @click="selectOption(item1, index)">
                                        {{ item1.optionNo }}. {{ item1.optionContent }}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="emam-optiond-each" :class="{ 'select': item.work === item1.optionNo }"
                                        v-for="(item1, index1) in item.itemOptionList" :key="index1"
                                        @click="selectOption(item1, index)">
                                        {{ item1.optionContent }}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="all-btn" v-if="index + 1 === rows.length && readonly === false">
                        <div class="submit-btn blue" @click="submit">提交答案</div>
                    </div>
                    <div class="result-content" v-if="readonly === true">
                        <div class="emam-head">
                            <div class="emam-head-left">
                                <div class="emam-type-icon"></div>
                                <div class="emam-type">答案</div>
                            </div>
                        </div>
                        <div class="result-list">
                            <div class="result-each">正确答案：{{ item.answer }}</div>
                            <div class="result-each" :class="{ 'red': item.answer !== item.work }">您的答案：{{ item.work }}</div>
                        </div>

                    </div>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
import { listExamItem, submitExamResult } from '@/api/common'   //路径
import { showToast } from 'vant';
export default {
    name: 'ExamWorkPage',
    props: ['id'],
    data() {
        return {
            merchantId: '',
            examId: '',
            teachingId: '',
            rows: {},
            score: 0, // 及格分
            startBtnShow: false,
            resultDisplay: '0', // 0：不显示明细结果 1：显示明细结果
            readonly: false,
            // examResult: [],
            examProId: ''
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.examId = this.$route.query.teachingId;
        this.teachingId = this.$route.query.teachingId;
        this.examProId = this.$route.query.examProId;
        this.readonly = this.$route.query.result === '1' ? true : false;
        if (this.readonly) {
            let list = localStorage.getItem('examResult') || null;
            const propName = 'examResult' + this.examId;
            if (list != null &&  JSON.parse(list)[propName] != null) {
                this.rows = JSON.parse(list)[propName];
            }
        } else {
            this.getExamItemList()
        }
    },
    methods: {
        getExamItemList() {
            let params = {
                'teachingGatherId': this.examId,
            };
            listExamItem(params).then((res) => {
                if (res.code === 200) {
                    this.resultDisplay = res.resultDisplay;
                    let list = res.rows;
                    list.forEach((element) => {
                        if (element.type === '2') {
                            let right = {
                                'optionNo': 'T',
                                'optionContent': '正确'
                            }
                            let error = {
                                'optionNo': 'F',
                                'optionContent': '错误'
                            }
                            element.itemOptionList.push(right)
                            element.itemOptionList.push(error)
                        }
                        // if(this.readonly && this.examResult.length > 0) {
                        //     element.work = this.examResult[index];
                        // }
                    });
                    this.score = res.score;
                    this.rows = res.rows;
                } else {
                    showToast(res.msg);
                }
            })
        },
        selectOption(item1, index) {
            let item = this.rows[index];
            if (this.readonly) {
                return;
            }
            // 单选和判断
            if (item.type === '0' || item.type === '2') {
                item.work = item1.optionNo
                if (index + 1 < this.rows.length) {
                    this.$refs.swipe.next();
                }
            }
            // 多选
            if (item.type === '1') {
                if (item.work === undefined || item.work === "") {
                    item.work = item1.optionNo;
                } else if (item.work.includes(item1.optionNo)) {
                    item.work = item.work.split(item1.optionNo).join("");
                } else {
                    let num = item.work + item1.optionNo;
                    item.work = this.sortOption(num);
                }
            }
        },
        sortOption(str) {
            str = [...str].sort((a, b) => {
                return a.localeCompare(b, "zh-CN")
            }).join("");
            return str;
        },
        submit() {
            if (this.rows.length === 0) {
                showToast('未设置题目');
                return;
            }
            let pass = true;
            let rightNum = 0
            for (let i = 0; i < this.rows.length; i++) {
                if (this.rows[i].work === undefined || this.rows[i].work === '') {
                    pass = false;
                    break;
                }
                if (this.rows[i].work === this.rows[i].answer) {
                    rightNum++;
                }
            }

            if (!pass) {
                showToast('请完成答题');
                return;
            }
            let params = {
                examId: this.examProId,
                score: Math.round(rightNum / this.rows.length * 100),
                countRight: rightNum,
                countError: this.rows.length - rightNum,
                pass: Math.round(rightNum / this.rows.length * 100) > this.score ? '1' : '0'
            };
            let that = this;
            submitExamResult(params).then((res) => {
                if (res.code !== 200) {
                    showToast(res.msg);
                } else {
                    // let workList =  that.rows.map(obj => obj.work);
                    // that.examResult = workList;
                    let oldExamResult = localStorage.getItem('examResult') || null;
                    const propName = 'examResult' + that.examId;
                    if (oldExamResult != null) {
                        let oldObject = JSON.parse(oldExamResult);
                        oldObject[propName] = that.rows;
                        localStorage.setItem('examResult', JSON.stringify(oldObject));
                    } else {
                        let newExamResult = {};
                        newExamResult[propName] = that.rows;
                        localStorage.setItem('examResult', JSON.stringify(newExamResult));
                    }
                    that.$message({
                        duration: 1000,
                        message: '提交成功',//提示的信息
                        type: 'success',//类型是成功
                        onClose: () => {
                            that.$router.push({
                                path: '/examDetail/' + that.merchantId, query: {
                                    teachingId: that.teachingId,
                                }
                            });
                        }
                    });
                }
            })
        }
    }
}
</script>

<style scoped>
.emam-list {
    overflow: hidden;
}

.my-swipe {
    width: 100vw;
    height: 100vh;
    background-color: #f5f5f5;
    overflow: hidden;
}

.emam-swipe-each {
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    width: calc(100vw - 30px);
    height: calc(100vh - 20px);
}

.emam-each {
    flex: 1%;
    background: #fff;
}

.emam-head {
    padding: 0 15px;
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E5E5E5;
}

.emam-type {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
}

.emam-head-left {
    display: flex;
    align-items: center;
}

.emam-type-icon {
    margin-right: 5px;
    width: 2px;
    height: 14px;
    background: #2087E2;
}

.emam-index {
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #333333;
    letter-spacing: 0;
    text-align: right;
    font-weight: 400;
}

.emam-index span {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #1485E5;
    letter-spacing: 0;
    text-align: right;
    font-weight: 500;
}

.emam-info {
    padding: 15px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 400;
}

.emam-content {
    margin-bottom: 30px;
}

.emam-optiond-list {
    overflow: hidden;
}

.emam-optiond-each {
    padding: 8px 15px;
    margin-bottom: 10px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 2px;
}

.emam-optiond-each.select {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #2087E2;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 500;
    background: #E8F3FC;
    border: 1px solid #2087E2;
}

.all-btn {
    padding: 0 40px;
    margin: 20px 0 30px 0;
    overflow: hidden;
}

.result-content {
    margin-top: 5px;
    height: 190px;
    background: #fff;
}

.result-list {
    padding: 15px;
    text-align: left;
    overflow: hidden;
}

.result-each {
    margin-bottom: 10px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #13D275;
    letter-spacing: 0;
    font-weight: 500;
}

.result-each.red {
    color: #F11515;
}

.submit-btn {
    margin-bottom: 15px;
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #CCCCCC;
    border-radius: 32px;
}

.submit-btn.blue {
    background: #0095D9;
}
</style>